import ModalContainer from '@elements/ModalContainer'
import AgeVerification from '@forms/AgeVerification'
import { useNavigate } from 'react-router-dom'

const SignupAgeVerificationModal = ({ isOpen }) => {
  const navigate = useNavigate()

  const handleConfirmation = () => 
    navigate('?modal-signup=true&remove_background=true')

  return (
    <ModalContainer open={isOpen}>
      <AgeVerification afterConfirmationCallback={handleConfirmation} />
    </ModalContainer>
  )
}

export default SignupAgeVerificationModal
